/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

// Load fonts
require('typeface-roboto');
require('./content/assets/fonts/font-face.css');
